import { Component, Input, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { StringsService } from '../../services/strings/strings.service';
import { AppSettings } from '../../PRE-LOAD/app-settings';
import { Journey, JourneySteps } from '../../types/strings.type';
import { Router } from '@angular/router';
import { ErrorService } from '../../services/errors/error.service';

@Component({
    selector: 'rttd-journey-indicator',
    templateUrl: './journey-indicator.component.html',
    styles: [
        require('./journey-indicator.component.scss').default.toString(),
        require(`./journey-indicator.component.${environment.brand}.scss`).default.toString()
    ]
})
export class JourneyIndicatorComponent {

    @Input() content: Journey;
    @Input() currentStep: number;
    @Input() steps: Array<JourneySteps>;

    constructor(
        private stringsService: StringsService,
        public appSettings: AppSettings,
        private router: Router
    ) {

        if (this.steps == null) {
            this.steps = [
                {
                    step: 1,
                    label: '1',
                    route: 'select-model',
                    isActive: true
                },
                {
                    step: 2,
                    label: '2',
                    route: 'select-appointment',
                    isActive: false
                },
                {
                    step: 3,
                    label: '3',
                    route: 'personal-information',
                    isActive: false
                }
            ];
        }
    }

    goBackOneStep() {
        this.currentStep = this.currentStep - 1;
        this.router.navigate([this.steps[(this.currentStep - 1)].route], { skipLocationChange: true, fragment: this.steps[(this.currentStep - 1)].fragment  });
    }

}
